import React from 'react';
import { Button, CssBaseline, Grid, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import Program from './Program';
// import Preparing from '../components/Preparing';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3, 0),
    textAlign: 'center',
  },
});

class ProgramList extends React.Component {
  // constructor(props) {
  //   super(props);
  // }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={1} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={10}>
              <MainTitle>Program at a Glance</MainTitle>
            </Grid>
            {/* 2022 CUSTOM :: 본 행사 시간표 적용 */}
            <Grid item xs={10}>
              <div style={{ textAlign: 'right' }}>
                <Button
                  onClick={() =>
                    window.open(
                      'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/%5BPRS+KOREA+2022%5D+Program+at+a+glance.pdf',
                      '_blank',
                    )
                  }
                  variant="contained"
                  color="primary"
                  disableElevation
                >
                  Program at a glance Download
                </Button>
              </div>
              <div className={classes.container}>
                <Program />
              </div>
              {/* 
              <Grid item xs={12}>
                <Preparing />
              </Grid> */}
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProgramList);
